/* eslint-disable max-len */
/* eslint-disable import/prefer-default-export */
import {
  useQueryClient,
  useMutation,
  useQuery,
} from '@tanstack/react-query';
import {
  getUser,
  getUsersList,
  createUser,
  updateUser,
} from '../../api/user';
import {
  IUser,
} from '../../types/users';

const useGetUser = (id?: string) => useQuery({
  queryKey: ['User', id],
  queryFn: async (): Promise<IUser | null | undefined> => getUser(id),
  keepPreviousData: true,
  enabled: !!id,
});

const useGetUsersList = (params?: { organisations?: string[] }) => useQuery({
  queryKey: ['UsersList', params],
  queryFn: async (): Promise<any | null> => getUsersList(params),
  keepPreviousData: true,
});

const useCreateUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<IUser>) => createUser(data),
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['Users'] });
      queryClient.invalidateQueries({ queryKey: ['UsersList'] });
    },
  });
};

const useUpdateUser = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: Partial<IUser>) => updateUser(data),
    onSuccess: async ({ user }) => {
      queryClient.invalidateQueries({ queryKey: ['Users'] });
      queryClient.invalidateQueries({ queryKey: ['UsersList'] });
      queryClient.setQueryData(['User', user._id], user);
    },
  });
};

export {
  useGetUser,
  useGetUsersList,
  useCreateUser,
  useUpdateUser,
};
